import { ErrorCodeMap } from './error-code-map.types';

/**
 * event-service `ExceptionErrorCodes` (range 2001-2176).
 * Generated from the backend registry; see error-codes.md.
 *
 * This map targets the CORRECT codes pending the backend fixes in B2B-1829 / B2B-1830:
 * - 2009 is currently defined twice (EVENT_INVALID_UUID and EVENT_INVALID_DESCRIPTION_TRANSLATION).
 *   2009 stays mapped to eventInvalidUuid; EVENT_INVALID_DESCRIPTION_TRANSLATION is expected to
 *   move to its own code 2157 (B2B-1829), which is pre-mapped here.
 * - 2072 (EVENT_INVALID_DATES) is currently never thrown because InvalidEventDatesException
 *   mistakenly throws 2003. Once fixed (B2B-1830) it will return 2072, pre-mapped here; 2003
 *   stays mapped to eventAlreadyFollowed.
 */
export const EVENT_ERROR_CODES: ErrorCodeMap = {
  2001: { key: 'eventNotFound', surface: true },
  2002: { key: 'eventCantBePublished', surface: true },
  2003: { key: 'eventAlreadyFollowed', surface: true },
  2004: { key: 'eventInvalidEndingTime', surface: true },
  2005: { key: 'eventInvalidStartingTime', surface: true },
  2006: { key: 'eventInvalidFilter', surface: false },
  2007: { key: 'eventInvalidName', surface: true },
  2008: { key: 'eventInvalidSlug', surface: false },
  2009: { key: 'eventInvalidUuid', surface: false },
  2010: { key: 'eventInvalidNumberLineup', surface: true },
  2011: { key: 'eventInvalidNumberMusicGenres', surface: true },
  2012: { key: 'eventInvalidNumberVibes', surface: true },
  2013: { key: 'agePolicyNotFound', surface: true },
  2014: { key: 'artistAlreadyExist', surface: true },
  2015: { key: 'artistAlreadyFollowed', surface: true },
  2016: { key: 'artistNotFound', surface: true },
  2017: { key: 'artistInvalidFilter', surface: false },
  2018: { key: 'artistInvalidFollowerCounter', surface: true },
  2019: { key: 'artistInvalidMixcloudUrl', surface: true },
  2020: { key: 'artistInvalidRecordLabel', surface: true },
  2021: { key: 'artistInvalidSlug', surface: false },
  2022: { key: 'artistInvalidSoundcloudUrl', surface: true },
  2023: { key: 'artistInvalidSpotifyUrl', surface: true },
  2024: { key: 'artistInvalidWebsiteUrl', surface: true },
  2025: { key: 'categoryNotAvailable', surface: true },
  2026: { key: 'categoryNotFound', surface: true },
  2027: { key: 'channelNotFound', surface: true },
  2028: { key: 'cityNotFound', surface: true },
  2029: { key: 'cityInvalidFilter', surface: false },
  2030: { key: 'cityInvalidCurrency', surface: true },
  2031: { key: 'venueAlreadyFollowed', surface: true },
  2032: { key: 'venueNotFound', surface: true },
  2033: { key: 'venueInvalidFilter', surface: false },
  2034: { key: 'venueInvalidFollowerCounter', surface: true },
  2035: { key: 'socialMediaInvalidReference', surface: true },
  2036: { key: 'socialMediaInvalidType', surface: true },
  2037: { key: 'invalidLanguage', surface: true },
  2038: { key: 'companyVenueNotFound', surface: true },
  2039: { key: 'companyVenueInvalid', surface: true },
  2040: { key: 'countryNotFound', surface: true },
  2041: { key: 'countryInvalidFilter', surface: false },
  2042: { key: 'countryInvalidIso', surface: false },
  2043: { key: 'countryInvalidSlug', surface: false },
  2044: { key: 'dressCodeNotFound', surface: true },
  2045: { key: 'facilityNotFound', surface: true },
  2046: { key: 'facilityInvalidFilter', surface: false },
  2047: { key: 'facilityInvalidId', surface: false },
  2048: { key: 'facilityInvalidName', surface: true },
  2049: { key: 'facilityInvalidSlug', surface: false },
  2050: { key: 'foodTypeNotFound', surface: true },
  2051: { key: 'foodTypeInvalidFilter', surface: false },
  2052: { key: 'foodTypeInvalidId', surface: false },
  2053: { key: 'foodTypeInvalidName', surface: true },
  2054: { key: 'foodTypeInvalidSlug', surface: false },
  2055: { key: 'musicGenreInvalidFilter', surface: false },
  2056: { key: 'musicGenreNotFound', surface: true },
  2057: { key: 'reviewInvalidDescription', surface: true },
  2058: { key: 'reviewInvalidFilter', surface: false },
  2059: { key: 'reviewInvalidId', surface: false },
  2060: { key: 'reviewInvalidRating', surface: true },
  2061: { key: 'reviewInvalidStatus', surface: true },
  2062: { key: 'reviewAlreadyExists', surface: true },
  2063: { key: 'reviewNotFound', surface: true },
  2064: { key: 'userNotFound', surface: true },
  2065: { key: 'venueCharacteristicInvalidFilter', surface: false },
  2066: { key: 'venueCharacteristicInvalidId', surface: false },
  2067: { key: 'venueCharacteristicInvalidName', surface: true },
  2068: { key: 'venueCharacteristicInvalidSlug', surface: false },
  2069: { key: 'venueCharacteristicNotFound', surface: true },
  2070: { key: 'vibeNotFound', surface: true },
  2071: { key: 'vibeInvalidFilter', surface: false },
  2072: { key: 'eventInvalidDates', surface: true },
  2073: { key: 'channelInvalidFilter', surface: false },
  2074: { key: 'eventChannelInvalidFilter', surface: false },
  2075: { key: 'policyTextInvalidId', surface: false },
  2076: { key: 'policyTextInvalidLocale', surface: false },
  2077: { key: 'policyTextInvalidName', surface: true },
  2078: { key: 'policyTextInvalidContent', surface: true },
  2079: { key: 'eventVisitInvalidLocale', surface: false },
  2080: { key: 'eventVisitInvalidTimestamp', surface: false },
  2081: { key: 'eventVisitInvalidDevice', surface: false },
  2082: { key: 'eventVisitInvalidOs', surface: false },
  2083: { key: 'eventVisitInvalidIp', surface: false },
  2084: { key: 'eventSiaeGenreCantBeModified', surface: true },
  2085: { key: 'eventIncidenzaIntrattenimientoCantBeModified', surface: true },
  2086: { key: 'companyVenueChannelInvalidFilter', surface: false },
  2087: { key: 'companyNotFound', surface: true },
  2088: { key: 'invalidEventTicketMaxCapacity', surface: true },
  2089: { key: 'invalidEventSiaeCapacity', surface: true },
  2090: { key: 'eventCantBeDeleted', surface: true },
  2091: { key: 'invalidMaxTicketQuantity', surface: true },
  2092: { key: 'noChannelsAssigned', surface: true },
  2093: { key: 'customerInvalidId', surface: false },
  2094: { key: 'customerInvalidEmailAddress', surface: true },
  2095: { key: 'customerNotFound', surface: true },
  2096: { key: 'customerInvalidLanguage', surface: true },
  2097: { key: 'eventPreregistrationInvalidId', surface: false },
  2098: { key: 'eventPreregistrationNotFound', surface: true },
  2099: { key: 'eventPreregistrationInvalidRequest', surface: true },
  2100: { key: 'invalidEmailAddress', surface: true },
  2101: { key: 'notificationFailed', surface: false },
  2102: { key: 'eventPreregistrationInvalidFilter', surface: false },
  2103: { key: 'eventInvalidExternalSalesUrl', surface: true },
  2104: { key: 'companyInvalidLogoUrl', surface: true },
  2105: { key: 'companyBankingDetailsInvalidBankNumber', surface: true },
  2106: { key: 'companyExternalIntegrationInvalidAudienceRepublicToken', surface: true },
  2107: { key: 'companyEmailInvalid', surface: true },
  2108: { key: 'musicGenreGroupInvalidSlug', surface: false },
  2109: { key: 'musicGenreGroupInvalidUuid', surface: false },
  2110: { key: 'musicGenreGroupInvalidName', surface: true },
  2111: { key: 'venueTypeInvalidId', surface: false },
  2112: { key: 'venueTypeInvalidName', surface: true },
  2113: { key: 'venueInvalidNumberOfTypes', surface: true },
  2114: { key: 'venueInvalidNumberMusicGenres', surface: true },
  2115: { key: 'musicGenreAlreadyRelated', surface: true },
  2116: { key: 'venueInvalidNumberVibes', surface: true },
  2117: { key: 'vibeAlreadyRelated', surface: true },
  2118: { key: 'facilityAlreadyRelated', surface: true },
  2119: { key: 'venueInvalidNumberFoodTypes', surface: true },
  2120: { key: 'foodTypeAlreadyRelated', surface: true },
  2121: { key: 'venueInvalidNumberVenueCharacteristics', surface: true },
  2122: { key: 'venueCharacteristicAlreadyRelated', surface: true },
  2123: { key: 'venueSocialMediaNotFound', surface: true },
  2124: { key: 'venueSocialMediaAlreadyRelated', surface: true },
  2125: { key: 'venueTypeNotFound', surface: true },
  2126: { key: 'widgetInvalidBackgroundColor', surface: true },
  2127: { key: 'widgetInvalidPrimaryColor', surface: true },
  2128: { key: 'widgetInvalidActionsTextColor', surface: true },
  2129: { key: 'widgetInvalidPrimaryTextColor', surface: true },
  2130: { key: 'widgetInvalidAccentColor', surface: true },
  2131: { key: 'widgetInvalidDomainUrl', surface: true },
  2132: { key: 'widgetInvalidLogoUrl', surface: true },
  2133: { key: 'widgetInvalidLogoPictureUrl', surface: true },
  2134: { key: 'widgetInvalidAdditionalUrl', surface: true },
  2135: { key: 'widgetNotFound', surface: true },
  2136: { key: 'widgetInvalidLayoutType', surface: true },
  2137: { key: 'widgetAlreadyExists', surface: true },
  2138: { key: 'eventInvalidCoverAspectRatio', surface: true },
  2139: { key: 'videoCoverInvalidUuid', surface: false },
  2140: { key: 'videoCoverInvalidSource', surface: true },
  2141: { key: 'videoNotFound', surface: true },
  2142: { key: 'videoAlreadyInProgress', surface: true },
  2143: { key: 'eventAlreadyHasVideoCover', surface: true },
  2144: { key: 'videoCoverNotFound', surface: true },
  2145: { key: 'videoUploadDisabled', surface: true },
  2146: { key: 'companyNotAllowedForVideoUpload', surface: true },
  2147: { key: 'eventAlreadyPublished', surface: true },
  2148: { key: 'eventInvalidEndingTimeDisplayLabel', surface: true },
  2149: { key: 'filterSetNotFound', surface: true },
  2150: { key: 'filterSetInvalidId', surface: false },
  2151: { key: 'eventInvalidLocationReveal', surface: false },
  2152: { key: 'eventInvalidRevealAddressMode', surface: false },
  2153: { key: 'eventInvalidShowVenueMode', surface: false },
  2154: { key: 'eventRevealEmailAlreadySent', surface: true },
  2155: { key: 'eventLocationIsPublic', surface: true },
  2156: { key: 'eventRevealAddressModeIsNotManual', surface: true },
  2157: { key: 'eventInvalidDescriptionTranslation', surface: true },
  // 2171-2174 (delayed-delivery payload validation) stay unmapped on purpose: the backend message
  // names the offending field and cap, which is more useful than a generic translation.
  2175: { key: 'eventTicketsAlreadySent', surface: true },
  2176: { key: 'eventDelayedDeliveryPredatesCreation', surface: true },
};
